<template>
    <div>
        <!-- Title -->
        <div class="d-flex pb-3 mb-3 border-bottom-light justify-content-between align-items-center pointer" @click="toggleExpand">
            <div>
                <span class="font-weight-600">MIN/MAX SETTINGS</span>
                <span class="fs-small dark bold ml-2" v-if="selectedPrincingType">(Only available in prices per person)</span>
            </div>
            <i class="ico mx-0 fs-normal" :class="{'ico-arrow-top':group.rulesExpanded, 'ico-arrow-bottom':!group.rulesExpanded}"></i>
        </div>

        <!-- Shown if expanded -->
        <div class="panelHolder" :class="{closed: !group.rulesExpanded}">
            <template>
                <div>
                    <div class="form-group row">
                        <div class="col-sm-12">
                            <div>
                                <div class="bg-lighter border-bottom-light border-top-light py-2">
                                    <span class="bold dark pl-3" >Booking</span>
                                </div>

                                <div class="py-2 ml-3">
                                    <label>Participants (PAX) rules
                                        <span class="color-6 fs-smaller ml-2" v-if="validateRulesPaxBook">Maximum value must be greater than minimum value</span>
                                    </label>
                                    <div class="d-flex mt-3 ">

                                        <div class="d-flex align-items-center mr-3">
                                            <input type="number" style="width: 60px;" :disabled="disabled || selectedPrincingType"  :class="{'pointer':!disabled, 'notAllowed':disabled || selectedPrincingType}" v-model="minimumPaxPerBooking" @input="minBookingUpdate">
                                            <label class="w-100 ml-2">Minimun</label>
                                        </div>
                                        <div class="d-flex align-items-center">
                                            <input type="number" style="width: 60px;" :disabled="disabled || selectedPrincingType"  :class="{'pointer':!disabled, 'notAllowed':disabled || selectedPrincingType}" v-model="maximumPaxPerBooking" @input="maxBookingUpdate">
                                            <label class="w-100 ml-2">Maximum</label>
                                        </div>
                                    </div>
                                </div>

                                <div class="py-1 ml-3 radios">
                                    <div v-if="group.minimumPaxPerBooking > 0 || group.maximumPaxPerBooking > 0">
                                        <span class="fs-small">If the participants' rules are not fulfilled:</span>
                                        <div class="d-flex justify-content-between mt-2" style="width:60%;">
                                            <radio  v-model="group.rejectBookingBasedOnMinMax" :value="true" :disabled="disabled || selectedPrincingType"  @input="productAcivateUpdateFlag('minMaxRules')">
                                                Block bookings
                                            </radio>
                                            <radio  v-model="group.rejectBookingBasedOnMinMax" :value="false" :disabled="disabled || selectedPrincingType"  @input="productAcivateUpdateFlag('minMaxRules')">
                                                Pending to confirm
                                            </radio >
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div>
                                <div class="bg-lighter border-bottom-light border-top-light py-2">
                                    <span class="bold dark pl-3">Event</span>
                                </div>
                                <div class="py-2 ml-3">
                                    <label >Participants (PAX) rules
                                        <span class="color-6 fs-smaller ml-2" v-if="validateRulesPaxEvent">Value must be between minimum and maximum</span>
                                    </label>
                                    <div class="mt-2 ">
                                        <div class="py-2">
                                            <span class="fs-small">If a minimum PAX per event is set, bookings are pending until this minimum is reached </span>
                                        </div>
                                        <div class="d-flex align-items-center ">
                                            <input type="number" style="width: 60px;" :disabled="disabled || selectedPrincingType"  :class="{'pointer':!disabled, 'notAllowed':disabled || selectedPrincingType}" v-model="minimumLotation" @input="lotationEventUpdate">
                                            <label class="w-100 ml-2">Minimun</label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
    import extendedVSelect from '@/extends/vue-select'
    import { PricingTypes } from '@/enums/pricingType'

    export default {
        created() {
            // If we are creating product
            if (!this.group.minimumPaxPerBooking) { this.$set(this.group, 'minimumPaxPerBooking', 0)};
            if (!this.group.maximumPaxPerBooking) {this.$set(this.group, 'maximumPaxPerBooking', 0)};
            if (!this.group.minimumLotation) {this.$set(this.group, 'minimumLotation', 0)};
            if (!this.group.rejectBookingBasedOnMinMax) {this.$set(this.group, 'rejectBookingBasedOnMinMax', false)};
        },
        props: {
            form: {
                default: null
            },
            group:{
                default: null
            },
            disabled: {
                type: Boolean,
                default: false
            },
            readOnly: {
                type: Boolean,
                default: false
            },
        },
        watch: {
            //if princingType per Order set rules Pax to 0
            'group.selectedPrincingType': {
                handler(newVal) {
                    if (newVal.id == PricingTypes.PerOrder) {
                        this.group.minimumPaxPerBooking = 0;
                        this.group.maximumPaxPerBooking = 0;
                        this.group.minimumLotation = 0;
                        this.group.rejectBookingBasedOnMinMax = false;
                        this.productAcivateUpdateFlag('minMaxRules');
                    } 
                },
            }
        },
        computed: {
            selectedPrincingType() {
                return this.group && this.group.selectedPrincingType && this.group.selectedPrincingType.id === PricingTypes.PerOrder;
            },
            minimumPaxPerBooking: {
                get() {
                    return this.group.minimumPaxPerBooking === 0 ? '' : this.group.minimumPaxPerBooking;
                },
                set(value) {
                    this.group.minimumPaxPerBooking = value === '' ? 0 : parseInt(value);
                }
            },
            maximumPaxPerBooking: {
                get() {
                    return this.group.maximumPaxPerBooking === 0 ? '' : this.group.maximumPaxPerBooking;
                },
                set(value) {
                    this.group.maximumPaxPerBooking = value === '' ? 0 : parseInt(value);
                }
            },
            minimumLotation: {
                get() {
                    return this.group.minimumLotation === 0 ? '' : this.group.minimumLotation;
                },
                set(value) {
                    this.group.minimumLotation = value === '' ? 0 : parseInt(value);
                }
            },
            validateRulesPaxBook() {
                if (this.group.minimumPaxPerBooking != 0 && this.group.maximumPaxPerBooking != 0) {
                    if (this.group.minimumPaxPerBooking >= this.group.maximumPaxPerBooking) {
                        this.$emit('isReadyToSubmit', true);

                        return true;
                    } else {
                        this.$emit('isReadyToSubmit', false);

                        return false;
                    } 
                } else {
                    this.$emit('isReadyToSubmit', false);

                    return false;
                }
            },
            validateRulesPaxEvent() {
                if (
                    this.group.minimumLotation != 0 && this.group.minimumLotation <= this.group.minimumPaxPerBooking && this.group.minimumPaxPerBooking != 0 ||
                    this.group.minimumLotation != 0 && this.group.minimumLotation >= this.group.maximumPaxPerBooking && this.group.maximumPaxPerBooking != 0
                ) {
                    this.$emit('isReadyToSubmit', true);
                    
                    return true;
                } else {
                    this.$emit('isReadyToSubmit', false);
                    
                    return false;
                }
            },
        },
        methods: {
            toggleExpand() {
                if (!this.group.rulesExpanded) {
                    this.$set(this.group, 'rulesExpanded', true);
                } else {
                    this.group.rulesExpanded = !this.group.rulesExpanded;
                }
            },
            minBookingUpdate(event) {
                this.group.minimumPaxPerBooking = event.target.value === '' ? 0 : parseInt(event.target.value);
                this.productAcivateUpdateFlag('minMaxRules');
            },
            maxBookingUpdate(event) { 
                this.group.maximumPaxPerBooking = event.target.value === '' ? 0 : parseInt(event.target.value);
                this.productAcivateUpdateFlag('minMaxRules');
            },
            lotationEventUpdate(event) {
                this.group.minimumLotation = event.target.value === '' ? 0 :  parseInt(event.target.value);
                this.productAcivateUpdateFlag('minMaxRules');
            }
        },
        components: {
            vSelect: extendedVSelect
        }
    }
</script>

<style lang="scss" scoped="">
    .panelHolder {
        &.closed {
            max-height: 0;
            overflow: hidden;
        }
    }  

    .radios {
        height: 70px;
    }
</style>



// WEBPACK FOOTER //
// MinMaxManager.vue?d88c56aa